// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.meeting-container{
    width:100%;
    height: 100px;align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
    font-family: "PlusJakartaSans";
}
.meeting-title{
    background-color: rgb(13, 13, 48);
    color:white;
    padding:1rem;
    font-family: "PlusJakartaSans";
    display: flex;
    align-items: center;
    justify-content: space-between;
    
}
.meeting-content-footer-container{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height:75vh;
    align-content: space-between;
}
.meeting-content{
  display:flex;
  flex-direction: column;
  font-family: "PlusJakartaSans";
}
.meeting-content > div{
    width:100%;
}
.meeting-content,.meeting-footer{
    padding:21px;
}

.calender-input{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top:0.5rem;
    padding-left:0.5rem;
    padding-right:0.5rem;
}
.time-container{
    display:flex;
    justify-content: space-between;
    align-items: center;
}
.start-time-container,.end-time-container{
   display: flex;
   flex-direction: column;
   width:48%;
}
.time{
    width:100%;
    justify-content: flex-end;
    align-items: center;
    display:flex;
    border:1px solid rgb(235, 237, 240);
    border-radius: 0.25rem;
    padding-left:0.5rem;
    padding-right:0.5rem;
}
.details-cotainer{
    display:flex;
    flex-direction:column;
    width:100%;
    justify-content: space-between;
    align-items: flex-start;
}
.details-textarea{
    width:100%;
    height:4rem;
    border-radius:0.25rem;
    border:1px solid rgb(235, 237, 240);
}
.time,.calender-input{
    height:3rem;
    border:1px solid rgb(235, 237, 240);
}
.date-container,.time-container,.details-cotainer,.participants-container{
    margin-bottom:1.25rem;
}
.meeting-content-label{
    margin-bottom:0.5rem;
}
.meeting-footer{
    display:flex;
    justify-content: flex-end;
    align-items: center;
}
.cancel-btn{
    border: 1px solid rgb(64, 64, 242);
    color:rgb(64, 64, 242);
    background-color: white;
    width:4rem;
    font-family: "PlusJakartaSans";
    border-radius:0.25rem;
    padding:0.25rem;
    text-align:center;
}
.save-btn{
    border:1px solid rgb(64, 64, 242);
    background-color:rgb(64, 64, 242);
    color: white;
    width:3.5rem;
    font-family: "PlusJakartaSans";
    padding:0.25rem;
    text-align:center;
}

`, "",{"version":3,"sources":["webpack://./src/pages/report/components/Meeting.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,aAAa,CAAC,mBAAmB;IACjC,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;AACA;IACI,iCAAiC;IACjC,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,8BAA8B;;AAElC;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW;IACX,4BAA4B;AAChC;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,8BAA8B;AAChC;AACA;IACI,UAAU;AACd;AACA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,YAAY;IACZ,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;GACG,aAAa;GACb,sBAAsB;GACtB,SAAS;AACZ;AACA;IACI,UAAU;IACV,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,mCAAmC;IACnC,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,YAAY;IACZ,qBAAqB;IACrB,UAAU;IACV,8BAA8B;IAC9B,uBAAuB;AAC3B;AACA;IACI,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,mCAAmC;AACvC;AACA;IACI,WAAW;IACX,mCAAmC;AACvC;AACA;IACI,qBAAqB;AACzB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,8BAA8B;IAC9B,qBAAqB;IACrB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,iCAAiC;IACjC,iCAAiC;IACjC,YAAY;IACZ,YAAY;IACZ,8BAA8B;IAC9B,eAAe;IACf,iBAAiB;AACrB","sourcesContent":[".meeting-container{\r\n    width:100%;\r\n    height: 100px;align-items: center;\r\n    justify-content: center;\r\n    display: flex;\r\n    flex-direction: column;\r\n    font-family: \"PlusJakartaSans\";\r\n}\r\n.meeting-title{\r\n    background-color: rgb(13, 13, 48);\r\n    color:white;\r\n    padding:1rem;\r\n    font-family: \"PlusJakartaSans\";\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    \r\n}\r\n.meeting-content-footer-container{\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    height:75vh;\r\n    align-content: space-between;\r\n}\r\n.meeting-content{\r\n  display:flex;\r\n  flex-direction: column;\r\n  font-family: \"PlusJakartaSans\";\r\n}\r\n.meeting-content > div{\r\n    width:100%;\r\n}\r\n.meeting-content,.meeting-footer{\r\n    padding:21px;\r\n}\r\n\r\n.calender-input{\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n    margin-top:0.5rem;\r\n    padding-left:0.5rem;\r\n    padding-right:0.5rem;\r\n}\r\n.time-container{\r\n    display:flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n.start-time-container,.end-time-container{\r\n   display: flex;\r\n   flex-direction: column;\r\n   width:48%;\r\n}\r\n.time{\r\n    width:100%;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n    display:flex;\r\n    border:1px solid rgb(235, 237, 240);\r\n    border-radius: 0.25rem;\r\n    padding-left:0.5rem;\r\n    padding-right:0.5rem;\r\n}\r\n.details-cotainer{\r\n    display:flex;\r\n    flex-direction:column;\r\n    width:100%;\r\n    justify-content: space-between;\r\n    align-items: flex-start;\r\n}\r\n.details-textarea{\r\n    width:100%;\r\n    height:4rem;\r\n    border-radius:0.25rem;\r\n    border:1px solid rgb(235, 237, 240);\r\n}\r\n.time,.calender-input{\r\n    height:3rem;\r\n    border:1px solid rgb(235, 237, 240);\r\n}\r\n.date-container,.time-container,.details-cotainer,.participants-container{\r\n    margin-bottom:1.25rem;\r\n}\r\n.meeting-content-label{\r\n    margin-bottom:0.5rem;\r\n}\r\n.meeting-footer{\r\n    display:flex;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n}\r\n.cancel-btn{\r\n    border: 1px solid rgb(64, 64, 242);\r\n    color:rgb(64, 64, 242);\r\n    background-color: white;\r\n    width:4rem;\r\n    font-family: \"PlusJakartaSans\";\r\n    border-radius:0.25rem;\r\n    padding:0.25rem;\r\n    text-align:center;\r\n}\r\n.save-btn{\r\n    border:1px solid rgb(64, 64, 242);\r\n    background-color:rgb(64, 64, 242);\r\n    color: white;\r\n    width:3.5rem;\r\n    font-family: \"PlusJakartaSans\";\r\n    padding:0.25rem;\r\n    text-align:center;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
